import styles from './login.module.scss';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { WCircularProgress, WSkeleton, WTypography } from '../../components/wrappers/wrapper';

import { localStorageService, STORAGE_KEY } from '../../services/local-storage.service';
import Logo from 'components/molecules/logo/logo';
import Button from 'components/atoms/button/button';
import authService from 'services/auth.service';
import { UserContext } from 'contexts/userContext';
import { ILoginRes } from 'models/common';
import { ProjectContext } from 'contexts/projectContext';
import helperService from 'services/helper.service';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(UserContext);
  const { projectData } = useContext(ProjectContext);

  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get('token');
  const hasError = queryParams.get('hasError');

  const [loading, setLoading] = useState(!!paramValue);
  const [projectLoading, setProjectLoading] = useState(true);

  useEffect(() => {
    if (!projectData) return;
    setProjectLoading(false);
  }, [projectData]);

  useEffect(() => {
    if (hasError) {
      helperService.showToast('error', 'Token expired or malformed. Please login again');
    }

    if (paramValue) {
      login(paramValue);
      return;
    }
    const token = localStorageService.getItem(STORAGE_KEY.TOKEN);
    if (token) {
      navigate('/home');
    }
  }, []);

  const handleClickLogin = () => {
    const url = process.env.REACT_APP_BLINK_PAGE_CLIENT_URL;
    window.location.href = `${url}/authentication`;
  };

  const handleClickWithoutLogin = () => {
    navigate('/home');
  };

  const login = async (token: string) => {
    setLoading(true);
    try {
      const res = (await authService.singIn(token)) as ILoginRes;
      setUser(res.user);
      navigate('/home');
      window.location.reload();
    } catch (err) {
      setLoading(false);
    }
  };

  const dynamicButtonText = `Continue with ${projectData?.title}`;

  return (
    <div className={styles.context}>
      {loading ? (
        <WCircularProgress size={24} />
      ) : projectLoading ? (
        <div className={styles.login}>
          <Logo />
          <WSkeleton variant="rectangular" height={32} width={256}></WSkeleton>
          <div className={styles.actions}>
            <WSkeleton variant="rounded" height={49} width={350}></WSkeleton>
            <WSkeleton variant="rounded" height={49} width={350}></WSkeleton>
          </div>
        </div>
      ) : (
        <div className={styles.login}>
          <Logo className={styles.logo} />
          <WTypography className={styles.message}>Log in to your account</WTypography>
          <div className={styles.actions}>
            <Button type='primary' radius="2rem" onClick={handleClickLogin}>
              {dynamicButtonText}
            </Button>
            <Button type="primaryOutline" radius="2rem" onClick={handleClickWithoutLogin}>
              Continue without login
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginPage;
